import request from '@/utils/request'


// 查询直播分享记录列表
export function listShare(query) {
  return request({
    url: '/live/share/list',
    method: 'get',
    params: query
  })
}

// 查询直播分享记录分页
export function pageShare(query) {
  return request({
    url: '/live/share/page',
    method: 'get',
    params: query
  })
}

// 查询直播分享记录详细
export function getShare(data) {
  return request({
    url: '/live/share/detail',
    method: 'get',
    params: data
  })
}

// 新增直播分享记录
export function addShare(data) {
  return request({
    url: '/live/share/add',
    method: 'post',
    data: data
  })
}

// 修改直播分享记录
export function updateShare(data) {
  return request({
    url: '/live/share/edit',
    method: 'post',
    data: data
  })
}

// 删除直播分享记录
export function delShare(data) {
  return request({
    url: '/live/share/delete',
    method: 'post',
    data: data
  })
}
